export default __webpack_public_path__ + "static/media/Enovia.aeff1df0.png";